import React from 'react';
import { connect } from 'react-redux';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Loader from '../../../organisms/loader/Loader';
import Paper from '@material-ui/core/Paper';
import { API_ROOT } from '../../../../baseUrls';
import MessageReceived from './MessageReceived';
import MessageSent from './MessageSent';
import Container from '@material-ui/core/Container';
import './Talk.css';
import AvatarWaitTimer from "../../../organisms/loader/AvatarWaitTimer";

class Talk extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      messages: [{
        received: true,
        text: '…'
      }],
      text: '',
      ready: false,
    };
  }

  componentDidMount() {
    this.startChat()
  }

  startChat() {
    if (this.props.mindfile && this.props.mindfile.id && this.props.avatarReady) {
      fetch(`${ API_ROOT }/mindfiles/${ this.props.mindfile.id }/avatar/start_talk.js`, {
        method: 'POST',
        credentials: 'include',
        headers: {'X-CSRF-Token': this.props.authenticity_token},
      })
      .then((response) => {
          response.json()
          .then((data) => {
            this.receiveMessage(data.text)
          })
          .catch((err) => {
            // TODO: handle error
          })
        }
      );
    } else {
      setTimeout(() => {
        this.startChat()
      }, 500)
    }
  }

  receiveMessage(text) {
    const new_messages = this.state.messages
    const last_message = new_messages[new_messages.length - 1]
    last_message.text = text
    new_messages[new_messages.length - 1] = last_message
    this.setState({messages: new_messages, ready: true})
  }

  updateText(e) {
    this.setState({ text: e.target.value })
  }

  enterText(e) {
    e.preventDefault()
    this.setState({
      messages: this.state.messages.concat({
        received: false,
        text: this.state.text
      }).concat({
        received: true,
        text: '…'
      }),
      text: '',
      ready: false,
    })
    setTimeout(function(){
      document.getElementById('avatar_input_field').scrollIntoView();
      document.getElementById('avatar_input_field').focus();
    })

    const data = new FormData();
    data.set('say', this.state.text);

    fetch(`${ API_ROOT }/mindfiles/${ this.props.mindfile.id }/avatar/do_talk.js`, {
      method: 'POST',
      credentials: 'include',
      body: data,
      headers: {'X-CSRF-Token': this.props.authenticity_token},
    })
    .then((response) => {
        response.json()
        .then((data) => {
          this.receiveMessage(data.text)
          setTimeout(function(){
            document.getElementById('avatar_input_field').scrollIntoView();
          })
        })
        .catch((err) => {
          // TODO: handle error
        });
      }
    )
  }

  render() {
    if (!this.props.mindfile || !this.props.mindfile.id) {
      return <Loader />
    }

    if (!this.props.avatarReady) {
      return <AvatarWaitTimer />;
    }

    const messages = this.state.messages.map((message, index) => {
      if (message.received) {
        const img_url = API_ROOT + "/mindfiles/"+this.props.mindfile.id+"/avatar/thumbnail?size=144&ts="+this.props.mindfile.timestamp;
        return <MessageReceived key={index} text={message.text} image={img_url}/>
      } else {
        return <MessageSent key={index} text={message.text}/>
      }
    })

    // const { classes } = this.props
    return (
      <Container>
        <Box mt={5} key={ this.props.mindfile.id ? 'upload-mindfile-loaded' : 'upload-mindfile-not-loaded' }>
          <Grid container direction="column" spacing={2}>
            { messages }
            <Grid container direction="row" item xs={12} cols={ 12 } spacing={2}>
              <Grid item xs={1} />
              <Grid item xs={10}>
                <Paper>
                  <form className="commentForm" onSubmit={ this.enterText.bind(this) }>
                    <TextField id="avatar_input_field" value={ this.state.text } disabled={ !this.state.ready } onChange={ this.updateText.bind(this) } placeholder="Say something here" fullWidth={ true } />
                  </form>
                </Paper>
              </Grid>
              <Grid item xs={1} />
            </Grid>
          </Grid>
        </Box>
      </Container>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    authenticity_token: state.auth.authenticity_token,
    mindfile: state.mindfile,
    avatarReady: !state.avatarReadyAt,
  }
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(Talk);
